import { FieldErrors, useFieldContext } from '../';
import { Label, RangeSliderV2 } from '../../Elements';

type RangeSliderFieldProps = {
	label?: string | React.ReactElement;
	max: number;
	min: number;
};

export const RangeSliderField = ({ label, max, min }: RangeSliderFieldProps) => {
	const field = useFieldContext<[number, number]>();

	// hide the error messages until the field has been touched
	const hideErrors = !field.state.meta.isTouched;

	return (
		<div className='flex flex-col'>
			<Label htmlFor={field.name} label={label} />
			<RangeSliderV2
				name={field.name}
				min={min}
				max={max}
				fieldValue={field.state.value}
				initialValue={field.state.value}
				handleChange={field.handleChange}
			/>
			<FieldErrors meta={field.state.meta} name={field.name} hideErrors={hideErrors} />
		</div>
	);
};
